// TableHeaders
export const headerUserTable: [string, number][] = [
  ['Name', 100],
  ['Contact Number', 150],
  ['Type', 100],
  ['Email Address', 140],
  ['Registration Date', 150],
  ['Status', 100],
  ['Action', 50],
];

export const headerErrorCodesTable: [string, number][] = [
  ['Ac Type', 50],
  ['Category', 50],
  ['Modal', 50],
  ['ErrorCode', 50],
  ['Description', 100],
  ['Troubleshooting', 100],
  ['Action', 50],
];
export const headerNotificationTable: [string, number][] = [
  ['Title', 100],
  ['Body', 200],
  ['createdAt', 90],
];

export const headerServicesTable: [string, number][] = [
  ['', 30],
  ['Service', 65],
  // ['Key', 65],s
  ['Category', 70],
  ['Status', 30],
  ['UpdatedAt', 60],
  ['CreatedAt', 60],
  ['Action', 20],
];

export const headerMaterialTable: [string, number][] = [
  ['Material Name', 25],
  ['Unit', 20],
  ['Price', 20],
  ['Status', 20],
  ['Action', 15],
];

export const headerToolTable: [string, number][] = [
  ['Tool Image', 15],
  ['Tool Name', 20],
  ['Code', 20],
  ['Description', 22],
  ['Status', 18],
  ['Action', 15],
];

export const headerTaxTable: [string, number][] = [
  ['Tax', 15],
  ['CGST', 20],
  ['SGST', 20],
  ['GST', 22],
  ['Effective From', 18],
  ['Status', 18],
];

export const headerBookingTable: [string, number][] = [
  ['Booking ID', 160],
  ['User Name', 130],
  ['Service Type', 130],
  ['Technician Name', 140],
  ['User Contact', 140],
  ['Booking Slot', 110],
  ['Status', 80],
  ['Action', 80],
];

export const headerProductTable: [string, number][] = [
  ['Product Name', 200],
  ['Brand', 140],
  ['AC Type', 120],
  ['Tonnage', 120],
  ['Model No', 150],
  ['MRP', 120],
  ['Customer Price', 150],
  ['Featured', 80],
  ['Action', 60],
];

export const headerLeavesTable: [string, number][] = [
  ['Technician Name', 50],
  ['Leave Type', 50],
  ['Dates', 50],
  ['Reason', 80],
  ['Status', 35],
  ['Action', 20],
];

export const headerPaymentTable: [string, number][] = [
  ['Booking ID', 70],
  ['Customer Name', 70],
  ['Customer No.', 70],
  ['Technician Name', 70],
  ['Technician No.', 70],
  // ['Technician Phone', 70],
  // ['Amount', 40],
  ['Amount', 70],
  ['Action', 30],
];

export const headerCouponTable: [string, number][] = [
  ['Image', 15],
  ['Code', 15],
  ['Name', 15],
  ['Discount', 12],
  ['Min Value', 12],
  ['Description', 20],
  ['Expiry Date', 15],
  ['Updated At', 15],
  ['Status', 12],
  ['Action', 10],
];

// Shared Figma layout for all three request list tables
const headerRequestListTable: [string, number][] = [
  ['Booking ID', 80],
  ['User Name', 70],
  ['Request Type', 60],
  ['Inspector Name', 70],
  ['User Contact', 80],
  ['Booking Slot', 80],
  ['Status', 50],
  ['Action', 50],
];

export const headerAmcRequestsTable = headerRequestListTable;

export const headerFreeConsultancyRequestTable = headerRequestListTable;

export const headerCopperPipingRequestTable = headerRequestListTable;

export const headerTechnicianTable: [string, number][] = [
  // [null, 20],
  ['Name', 70],
  ['Contact Number', 60],
  ['DOB', 80],
  ['Type', 50],
  ['Experience', 50],
  ['Position', 70],
  ['Status', 40],
  // ['Status', 30],
  ['Action', 35],
];

export const headerBrandTable: [string, number][] = [
  ['Brand Logo', 15],
  ['Brand Name', 50],
  ['UpdatedAt', 40],
  ['CreatedAt', 40],
  ['Number of Errorcode', 30],
  ['Status', 30],
  ['Action', 30],
];
export const headerZonesTable = [
  [null, 10],
  ['Name', 50],
  ['Pincodes', 200],
  ['isActive', 30],
  [null, 20],
];

export const acItems: { name: string }[] = [
  { name: 'Split AC' },
  { name: 'Vrv/vrf AC' },
  { name: 'Window AC' },
  { name: 'Ducted AC' },
  { name: 'Cassette AC' },
  { name: 'Tower AC' },
  { name: 'Concealed AC' },
];

export const SellOldACHeader: [string, number][] = [
  ['Request ID', 70],
  ['User Name', 70],
  ['Request Type', 40],
  ['Inspector Name', 70],
  ['User Contact', 50],
  ['Inspection Slot', 70],
  ['Status', 40],
  ['Action', 30],
];

export const headerRequestTable: [string, number][] = [
  ['Request ID', 90],
  ['Tool Name', 60],
  ['Type', 40],
  ['Technician Name', 80],
  ['Reason', 70],
  ['Quantity', 40],
  ['Status', 60],
  // ['Action', 35],
];
export const headerCancelledTable: [string, number][] = [
  ['Booking ID', 160],
  ['User Name', 130],
  ['Service Type', 130],
  ['User Contact', 140],
  ['Reason', 110],
  ['Status', 80],
  ['Action', 80],
];
